export const checkCardType = (number: string): string => {
  const rules = {
    // AmexCard: /^3[47][0-9]{13}$/, // 15
    // VisaCard: /^4[0-9]{12}(?:[0-9]{3})?$/, // 16
    // MasterCard: /^5[1-5]\d{14}$/, // 16
    // MaestroCard: /^(5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}$/, // 12-19

    AmexCard: /^3[47][0-9]{2}$/, // 15
    VisaCard: /^4[0-9]{3}$/, // 16
    MasterCard: /^5[1-5]\d{2}$/, // 16
    MaestroCard: /^(5018|5020|5038|6304|6759|6761|6763)$/, // 12-19
  };

  if (!number) return "";

  for (let key in rules) {
    if (rules[key].test(number)) {
      return key;
    }
  }
  return "";
};
